import React from "react";
import { AuthContext } from "../../components/AuthProvider";

/**
 * Hook to access the AuthContext value.
 *
 * @returns The AuthContext value.
 * @throws Will throw an error if used outside of a AuthContext provider.
 * @example
 * const auth = useAuth();
 */
function useAuth() {
  const auth = React.useContext(AuthContext);

  if (auth === undefined) {
    throw new Error("useAuth must be used within an AuthContextProvider.");
  }

  return auth;
}

export default useAuth;
